/** Query keys for the Team access console (Super Admin) and the owner's Team page. */
export const teamAccessKeys = {
	all: ['teamAccess'] as const,
	templates: () => [...teamAccessKeys.all, 'templates'] as const,
	summary: () => [...teamAccessKeys.all, 'summary'] as const,
	members: () => [...teamAccessKeys.all, 'members'] as const,
	memberList: (filters: Record<string, unknown>) => [...teamAccessKeys.members(), 'list', filters] as const,
	member: (id: number) => [...teamAccessKeys.members(), 'detail', id] as const,
	owners: (search: string) => [...teamAccessKeys.all, 'owners', search] as const,
	owner: (ownerUserId: number) => [...teamAccessKeys.all, 'owner', ownerUserId] as const,
	requests: (status: string) => [...teamAccessKeys.all, 'requests', status] as const,
	/** Bulk invite pre-flight: which roster emails/phones already have an account. */
	contactCheck: (signature: string) => [...teamAccessKeys.all, 'contactCheck', signature] as const,
	myTeam: () => [...teamAccessKeys.all, 'myTeam'] as const,
	/** A team member's own spending position (P3). */
	spendPosition: () => [...teamAccessKeys.all, 'spendPosition'] as const,
	/** Independent Supporter accounts (P4). Under `all`, so a team-access invalidate refreshes them too. */
	supporters: () => [...teamAccessKeys.all, 'supporters'] as const,
	supporterSummary: () => [...teamAccessKeys.supporters(), 'summary'] as const,
	supporterList: (filters: Record<string, unknown>) => [...teamAccessKeys.supporters(), 'list', filters] as const,
	supporter: (id: number) => [...teamAccessKeys.supporters(), 'detail', id] as const,
	supporterCandidates: (partyId: number, search: string) =>
		[...teamAccessKeys.supporters(), 'candidates', partyId, search] as const,
};
